export function directOrder() {
    if (window.history.replaceState) {
        window.history.replaceState(null, null, window.location.href);
    }

    const badArticlesCount = document.querySelector('[name="badArticlesCount"]');
    let n: number = 1;
    let timer: number;
    if (badArticlesCount) {
        n = parseInt(badArticlesCount.textContent) + 1;
    }

    const submit = document.getElementById('directOrderSubmit') as HTMLButtonElement;
    const orderNoWrapper = document.querySelector('.form-row-directorder-wrapper');

    if (orderNoWrapper) {
        const orderNoElement = orderNoWrapper.querySelector('.form-row-directorder');
        const templateHTML = orderNoElement?.outerHTML;

        orderNoWrapper.addEventListener('input', (e: any) => {
            if (e.target.id.includes('input-field-orderno')) {
                if (e.target.value.trim() !== '') {
                    const currentRow = e.target.closest('.form-row-directorder');
                    if (currentRow && currentRow.nextElementSibling === null) {
                        n++;
                        if (!templateHTML) return console.log('templateHTML is undefined');
                        const clone = document.createRange().createContextualFragment(templateHTML);
                        const newOrderNoInput = clone.querySelector('[id^="input-field-orderno"]') as HTMLElement;
                        newOrderNoInput.id = 'input-field-orderno-' + n;
                        const newLabel = clone.querySelector('[for^="input-field-orderno"]') as HTMLElement;
                        newLabel.setAttribute('for', 'input-field-orderno-' + n);
                        const newQuantityInput = clone.querySelector('[id^="input-field-quantity"]') as HTMLElement;
                        newQuantityInput.id = 'input-field-quantity-' + n;

                        const cloneInput = clone.querySelector('.form-field-orderno') as HTMLInputElement;
                        if (cloneInput) {
                            cloneInput.classList.remove('input-badArticle');
                            cloneInput.value = '';
                        }

                        createDirectOrderFields(clone, n);
                    }
                }
            }
            submit.disabled = false;
        });

        orderNoWrapper.addEventListener('focusout', (e: any) => {
            if (e.target.id.includes('input-field-orderno')) {
                const currentRow = e.target.closest('.form-row-directorder');
                if (currentRow && currentRow.nextElementSibling && e.target.value.trim() === '') {
                    currentRow.remove();
                }
            }
        });
    }

    submit && submit.addEventListener('click', (event) => {
        const input = (document.querySelector('.form-row-directorder [name="articleId"]') as HTMLInputElement).value;
        if (!input || input === '') event.preventDefault();
        clearTimeout(timer);
        timer = window.setTimeout(() => {
            // disable submit after first click
            submit.disabled = true;
        });
    });

    function createDirectOrderFields(fragment: DocumentFragment, n: number) {
        document.querySelector('.form-row-directorder-wrapper')?.appendChild(fragment);
    }
}